/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScoreSubmissionMatchResult
 */
export interface ScoreSubmissionMatchResult {
    /**
     * 
     * @type {string}
     * @memberof ScoreSubmissionMatchResult
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ScoreSubmissionMatchResult
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof ScoreSubmissionMatchResult
     */
    team1Score?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoreSubmissionMatchResult
     */
    team2Score?: number;
    /**
     * 
     * @type {string}
     * @memberof ScoreSubmissionMatchResult
     */
    winnerId?: string;
}

/**
 * Check if a given object implements the ScoreSubmissionMatchResult interface.
 */
export function instanceOfScoreSubmissionMatchResult(value: object): value is ScoreSubmissionMatchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ScoreSubmissionMatchResultFromJSON(json: any): ScoreSubmissionMatchResult {
    return ScoreSubmissionMatchResultFromJSONTyped(json, false);
}

export function ScoreSubmissionMatchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoreSubmissionMatchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'team1Score': json['team1Score'] == null ? undefined : json['team1Score'],
        'team2Score': json['team2Score'] == null ? undefined : json['team2Score'],
        'winnerId': json['winnerId'] == null ? undefined : json['winnerId'],
    };
}

export function ScoreSubmissionMatchResultToJSON(json: any): ScoreSubmissionMatchResult {
    return ScoreSubmissionMatchResultToJSONTyped(json, false);
}

export function ScoreSubmissionMatchResultToJSONTyped(value?: ScoreSubmissionMatchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
        'winnerId': value['winnerId'],
    };
}

